import * as React from "react";
import { AppUtils } from "source/framework/appUtils";
import { EventTypeNodes } from "source/models/eventType/eventTypeNodes";
import * as eventService from "source/models/services/eventService";
import { EventTypeTree } from "../EventTypeTree";

export interface IEventTypesSettingsProp {
    classes?: string;
    companyId: string;
    category: number;
    onClose: () => void;
}

export interface IEventTypesSettingsState {
    eventTypeNodes: EventTypeNodes;
}

export class EventTypesSettings extends React.Component<IEventTypesSettingsProp, IEventTypesSettingsState> {
    constructor(props: IEventTypesSettingsProp) {
        super(props);
        this.state = {
            eventTypeNodes: null
        };
    }
    
    getEventTypes = async (category: number): Promise<EventTypeNodes> => {
        return AppUtils.callService(() => eventService.getEventTypes(this.props.companyId, category), false);
    };

    componentDidMount(): void {
        this.getEventTypes(this.props.category)
            .then(eventTypeNodes => {
                if (!eventTypeNodes) return;
                this.setState({ eventTypeNodes });
            });
    }
    
    render() {
        const props = this.props;
        const state = this.state;
        if (!state.eventTypeNodes) return null;
        return (
            <EventTypeTree
                companyId={props.companyId}
                category={props.category}
                eventTypeNodes={state.eventTypeNodes}
                getEventTypes={this.getEventTypes}
            />
        );
    }
}